<div class="default-routes-dialog">
  <header class="default-routes-dialog__header">
    <div class="default-routes-dialog__header-text">
      <h2 class="default-routes-dialog__title">{{ 'rutas-predeterminadas' | translate }}</h2>
      <p class="default-routes-dialog__subtitle">{{ 'seleccionar-municipio-pantalla-defecto' | translate }}</p>
    </div>

    <button
      class="default-routes-dialog__close"
      mat-icon-button
      color="warn"
      mat-dialog-close
      type="button"
      [disabled]="saving || deleting"
      [matTooltip]="'cerrar' | translate"
      matTooltipClass="colortooltip"
      [attr.aria-label]="'cerrar' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content class="default-routes-dialog__content">
    <div class="default-routes-dialog__fields">
      <mat-form-field appearance="outline" class="default-routes-dialog__field">
        <mat-label>{{ 'municipio' | translate }}</mat-label>
        <mat-select [formControl]="municipioControl">
          @for (municipio of municipios; track municipio.IdMunicipio) {
            <mat-option [value]="municipio.IdMunicipio">
              {{ municipio.NombreMunicipio }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-grouped-search-select
        class="default-routes-dialog__field"
        [groups]="routeGroups"
        [selectedValue]="selectedRoute"
        (selectedValueChange)="onRouteChange($event)"
      >
      </app-grouped-search-select>
    </div>
  </mat-dialog-content>

  <footer class="default-routes-dialog__footer default-routes-dialog__footer--split" mat-dialog-actions>
    <button
      mat-stroked-button
      type="button"
      class="default-routes-dialog__delete-btn"
      [disabled]="!hasSavedRoutes || saving || deleting"
      (click)="deleteRoutes()"
    >
      {{ 'borrar-rutas' | translate }}
    </button>

    <div class="default-routes-dialog__footer-actions">
      <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving || deleting">
        {{ 'cancelar' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="saving || deleting">
        {{ 'guardar' | translate }}
      </button>
    </div>
  </footer>
</div>
